import { useFormContext } from 'react-hook-form';
import {
    AUTOMATIC_TAX_CALCULATION,
    IOrderSale,
    REQUIRE_TAX,
    TAX,
} from './order-sale-form';
import { useCalculateProductsTotal } from './helpers/use-calculate-products-total';

export function useSetOrderSaleTaxRequirement() {
    const rx = useFormContext<IOrderSale>();
    const { calculateProductsTotal } = useCalculateProductsTotal();

    const setOrderSaleTaxRequirement = (
        required: boolean,
        options: {
            accountAllowsAutomaticTaxCalculation?: boolean;
            automaticTaxCalculation?: boolean;
            taxToRestore?: IOrderSale['tax'];
        } = {},
    ) => {
        const account = rx.getValues('account') as IOrderSale['account'];
        const accountAllowsAutomaticTaxCalculation =
            options.accountAllowsAutomaticTaxCalculation ??
            !!account?.client_automatic_tax_calculation;
        const automaticTaxCalculation = required
            ? accountAllowsAutomaticTaxCalculation &&
              (options.automaticTaxCalculation ?? true)
            : false;
        const taxToRestore = Number(options.taxToRestore ?? 0);
        const hasTaxToRestore =
            required && Number.isFinite(taxToRestore) && taxToRestore !== 0;

        rx.setValue(REQUIRE_TAX, required, {
            shouldDirty: true,
            shouldValidate: true,
        });
        rx.setValue(AUTOMATIC_TAX_CALCULATION, automaticTaxCalculation, {
            shouldDirty: true,
            shouldValidate: true,
        });

        if (!required) {
            rx.setValue(TAX, 0, {
                shouldDirty: true,
                shouldValidate: true,
            });
        }

        if (hasTaxToRestore) {
            rx.setValue(TAX, taxToRestore, {
                shouldDirty: true,
                shouldValidate: true,
            });
        }

        // Preserve a previously entered IVA value on a manual re-enable. When
        // there is no value to restore, respect the previous automatic setting.
        calculateProductsTotal({
            automaticTaxCalculation: hasTaxToRestore
                ? false
                : automaticTaxCalculation,
        });
    };

    return { setOrderSaleTaxRequirement };
}
